import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chart_pie",
  "use": "chart_pie-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"chart_pie\"><path d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0M1.5 7c0-2.778 2.072-5.075 4.75-5.443v5.266l-2.363 4.706A5.5 5.5 0 0 1 1.5 7M7 12.5a5.5 5.5 0 0 1-1.773-.299L7.4 7.874l4.7 1.176A5.51 5.51 0 0 1 7 12.5m.75-6.085V1.557C10.428 1.925 12.5 4.222 12.5 7q-.001.301-.034.595z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol